import { useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule } from "ag-grid-community";
import { GetOrderByMobile } from "../../services/orderService";

import "ag-grid-community/styles/ag-theme-quartz.css";

const modules = [AllCommunityModule];

const SearchOrders = () => {
    const [mobile, setMobile] = useState("");
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    const columnDefs = useMemo(
        () => [
            { headerName: "Order Id", field: "orderId", flex: 1 },
            { headerName: "Date", field: "dateCreated", flex: 1.5 },
            { headerName: "Customer", field: "customerName", flex: 1.5 },
            { headerName: "Address", field: "address", flex: 2 },
            { headerName: "Mobile", field: "mobile", flex: 1.2 },
            { headerName: "City", field: "city", flex: 1 },
            { headerName: "State", field: "state", flex: 1 },
            { headerName: "Pincode", field: "pincode", flex: 1 },
            { headerName: "Amount", field: "totalAmount", flex: 1 },
            { headerName: "Payment", field: "paymentType", flex: 1 },

            {
                headerName: "Products",
                field: "product",
                flex: 5,
                wrapText: true,
                autoHeight: true,
            },
            { headerName: "Status", field: "courierStatus", flex: 1.5 },
            { headerName: "way Bill", field: "wayBill", flex: 1 },
            {
                field: "teleCaller",
                headerName: "Tele Caller", flex: 1.5
            },
            {
                field: "teamLeader",
                headerName: "Team Leader", flex: 1.5
            },
        ],
        []
    );

    const handleSearch = async () => {
        const mobileNo = mobile.trim();

        setMessage("");

        if (!mobileNo) {
            setOrders([]);
            setMessage("Please enter OrderId Or mobile number.");
            return;
        }

        // if (mobileNo.length > 4) {
        //     setOrders([]);
        //     setMessage("Please enter a valid number.");
        //     return;
        // }

        try {
            setLoading(true);

            const response = await GetOrderByMobile(mobileNo);

            if (response?.statusCode !== 200) {
                setOrders([]);
                setMessage(response?.message || "No orders found.");
                return;
            }

            const formattedData = (response.data ?? []).map((item) => ({
                orderId: item.id,
                dateCreated: item.dateCreated
                    ? new Date(item.dateCreated).toLocaleString()
                    : "",
                customerName: `${item.firstName ?? ""} ${item.lastName ?? ""}`.trim(),
                address: `${item.address ?? ""} ${item.address2 ?? ""}`.trim(),
                mobile: item.mobile ?? "",
                city: item.city ?? "",
                state: item.state ?? "",
                pincode: item.postalCode ?? "",
                totalAmount: item.gTotal ?? 0,
                paymentType: item.payment?.name ?? "",
                courierStatus: item.courierStatus ?? "",
                teleCaller: item.teleCaller ?? "",
                teamLeader: item.teamLeader ?? "",
                wayBill: item.wayBill ?? "",
                product:
                    item.getOrderItemDtos
                        ?.map(
                            (x) =>
                                `${x.productName} (Qty: ${x.quantity ?? 0}, Price: ${x.priceAtPurchase ?? 0})`
                        )
                        .join(", ") || "",
            }));

            setOrders(formattedData);

            if (formattedData.length === 0) {
                setMessage("No orders found.");
            }
        } catch (error) {
            console.error(error);
            setOrders([]);
            setMessage("Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mt-3">
            <h4>Search Orders</h4>

            <div className="row mb-3">
                <div className="col-md-4">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Mobile Number"
                        value={mobile}
                        maxLength={10}
                        onChange={(e) =>
                            setMobile(e.target.value.replace(/\D/g, ""))
                        }
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                handleSearch();
                            }
                        }}
                    />
                </div>

                <div className="col-md-2">
                    <button
                        className="btn btn-primary"
                        onClick={handleSearch}
                        disabled={loading}
                    >
                        {loading ? "Searching..." : "Search"}
                    </button>
                </div>
            </div>

            {message && (
                <div className="alert alert-info">{message}</div>
            )}

            <div
            // className="ag-theme-quartz"
            // style={{ width: "100%" }}
            >
                <AgGridReact
                    modules={modules}
                    rowData={orders}
                    columnDefs={columnDefs}
                    pagination
                    paginationPageSize={10}
                    animateRows
                    domLayout="autoHeight"
                    height="500px"
                    enableCellTextSelection
                    ensureDomOrder
                    suppressCellFocus={false}
                />
            </div>
        </div>
    );
};

export default SearchOrders;